module.exports = __webpack_public_path__ + "img/zh_con.13faae1d.png";